import { useNavigate } from "react-router-dom";
import { Sparkles, X } from "lucide-react";
import PricingCards from "@/components/PricingCards";

/**
 * "Upgrade to Pro" modal shown when a free user hits a Pro feature.
 * Plan copy comes from the admin-editable price cards (no hard-coded copy).
 * Usage:  <UpgradeModal open={...} onClose={...} featureName="AI Role-Play" />
 */
const UpgradeModal = ({ open, onClose, featureName = "this feature" }) => {
  const navigate = useNavigate();
  if (!open) return null;

  const pick = () => { onClose(); navigate("/billing"); };

  return (
    <div
      data-testid="upgrade-modal"
      className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm animate-fade-in-up overflow-y-auto"
      onClick={onClose}
    >
      <div
        className="glass rounded-3xl border border-primary/30 bg-gradient-to-br from-primary/10 to-transparent p-8 max-w-2xl w-full relative my-8"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          data-testid="upgrade-modal-close"
          onClick={onClose}
          className="absolute top-4 right-4 text-muted-foreground hover:text-foreground"
        >
          <X className="w-5 h-5" />
        </button>

        <div className="w-14 h-14 rounded-2xl bg-primary/20 flex items-center justify-center mb-4">
          <Sparkles className="w-7 h-7 text-primary" />
        </div>

        <h2 className="text-2xl font-bold mb-2">{featureName} is a Pro feature</h2>
        <p className="text-muted-foreground mb-6 text-sm">
          Unlock everything PassADC Pro offers. Pick the plan that fits your prep window.
        </p>

        <PricingCards paidOnly compact onSelect={pick} />
      </div>
    </div>
  );
};

export default UpgradeModal;
